import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'

//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'
import { fileActions, workflowActions } from '../../store/actions'
import { CustomLoadingOverlay, GenericContainer, Buttons } from '../../components'
import { identityValFunctions } from './IdentityValFunctions'
import { useProjectContext, coreFunctions } from '../../utils'

import {
    Typography,
    useMediaQuery,
    Dialog,
    IconButton,
    styled,
    Box, useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"
import { FormatColorResetTwoTone } from '@mui/icons-material'
import { useTranslation } from 'react-i18next';

const ScanContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    overflow: "hidden",
    border: "2px solid #999",
    // margin: '1em',
    borderRadius: 12,
    width: "100%",
    height: 300,
    ['@media only screen and (max-width: 812px)']: {
        width: '100%',
        // height: '30vh',
        marginTop: '0.5em',
        maxHeight: '46vh',
        height: 'fit-content',
    }
}));

export default function Carousel(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const context = useProjectContext()

    const [images, setImages] = useState([])
    const [list, setList] = useState([])
    const [loadView, setLoadView] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    const [newImage, setNewImage] = useState('')
    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [fileId, setFileId] = useState(0)
    const [doctName, setDocName] = useState(0)
    const [docCurrentId, setDocCurrentId] = useState(0)
    const [metadataExtraccion, setMetadataExtraccion] = useState([])

    const [sectionsDocsId, setSectionsDocsId] = useState(null)
    const [selfieMetadata, setSelfieMetadata] = useState(null)
    const [loadStatusStage, setLoadStatusStage] = useState(false)
    const [loadFileInfo, setLoadFileInfo] = useState(false)
    const [sections, setSections] = useState(false);
    const { t } = useTranslation();

    // const [metadata, setMetadata] = useState(null)

    const file = useSelector(state => state.FileInfo)
    const registroStatusStage = useSelector(state => state.RegStatusStage)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setSelfieMetadata(location.state.selfieMeta)
        setSectionsDocsId(location.state.docIds)
        // setMetadata(location.state.metadatos)
        setFileId(location.state.folioId)
        setDocName(location.state.docName)
        setDocCurrentId(location.state.documetId)
        setSections(location.state.sections)
        setMetadataExtraccion(location.state.metadataExtraccion)
        console.log("location.state.docName-----", location.state.docName)
        dispatch(workflowActions.RegisterStatusStage({
            File_id: location.state.folioId,
            Status: "ValidaciónFacial"
        }))
    }, [])

    useEffect(() => {
        // vgr: [67301, 67302] 
        if (file.items != undefined && file.items != null) {
            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
        }
    }, [file])

    useEffect(() => {
        // console.log('ids', context.docsIds)
        console.log("Ids Sections Docs: ", sectionsDocsId)
        if (sectionsDocsId != null) {
            // getImages(context.docsIds).then(response => {
            setLoadView(true)
            getImages(sectionsDocsId).then(response => {
                if (response != undefined && response != null) {
                    setImages(response)
                } else {
                    console.log("No se obtuvi respuesta de servicio de documentos.", response)
                }
            })
            setLoadView(false)
        }
    }, [sectionsDocsId])

    useEffect(() => {
        if (images != undefined && images != null) {
            setLoadView(true)
            if (images.length > 0) {
                setList(images.map((img, index) => {
                    return { key: index, image: img.Body.B64Content, name: img.Body.FileName.split('.')[0] }
                }))
                setLoadView(false)
            }
        }
    }, [images])

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    //This is to make an asyncronus petition 
    const getImages = async (arrayList) => {
        try {
            // console.log("getImages-----arrayList------ ", arrayList)
            setImages([])
            const iteracy = arrayList.map(async (docId) => {
                return await identityValFunctions.docRequest(docId)
            })
            //  console.log("iteracy----------- ", iteracy)
            return await Promise.all(iteracy)
        } catch {
            // console.log("Catch: -------getImages-------: ", arrayList)
            // getImages(arrayList)
            return null
        }
    }

    const getSectionName = (name) => {
        const nameSplit = name.split('_')
        return nameSplit[nameSplit.length - 1]
    }

    const reCapture = () => {
        dispatch(workflowActions.RegisterStatusStage({
            File_id: fileId,
            Status: "Inicializado"
        }))
        setLoadStatusStage(true)
    }

    const continueToForm = () => {
        // setLoadView(true)
        let nextStage = file.items.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = file.items.Id
        let stage = file.items
        let docName = doctName
        let documetId = docCurrentId
        let selfieMeta = selfieMetadata
        console.log("Name send------------------: ", docName, documetId)

        const nextComponent = 'ExtractionForm'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stage, folioId, sections, docName, documetId, selfieMeta, metadataExtraccion } })
    }

    const changeImg = (image) => {
        setNewImage(image)
        setOpenDialog(true)
    }

    useEffect(() => {
        console.log("registroStatusStage.items------- ", registroStatusStage.items)
        if (registroStatusStage.items != undefined && registroStatusStage.items != null && loadStatusStage) {
            dispatch(fileActions.GetFileInfo(fileId))
            setLoadStatusStage(false)
            setLoadFileInfo(true)

        } else if (registroStatusStage.error != undefined && registroStatusStage.error != null && loadStatusStage) {
            alert(registroStatusStage.error)
        }
    }, [registroStatusStage])

    useEffect(() => {
        // setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != undefined && loadFileInfo) {
            let nextStage = file.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let folioId = file.items.Id
            let stage = file.items

            let docIds = []
            let metadatos = []
            let selfieMeta = []
            let transId = null
            let sequences = 0
            let selectedCapture = ''
            localStorage.removeItem("TransactionId")
            setLoadFileInfo(false)

            const nextComponent = 'IdentityValidationComponent'
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, stage, docIds, metadatos, selfieMeta, transId, sequences, selectedCapture, metadataExtraccion } })
        }
        else if (file.error != undefined && loadFileInfo) {
            // alert(file.error)
            console.log("file.error----: ", file.error)
        }
    }, [file]);

    return (<GenericContainer>
        <Typography
            variant="h6"
            gutterBottom
            className={localStyles.stageTitle}>
            <b>{t("capture_id")}</b>
        </Typography>

        <div ref={ref} className={localStyles.wizardContainer}>
            {list.length > 0 && list.map(item => (
                <div key={item.key} onClick={() => { changeImg(item.image) }} style={{ textAlign: 'center' }} >
                    {console.log("item", item.name)}
                    {/* <div className={localStyles.carouselSection}> */}
                    <Typography><b>{(getSectionName(item.name) == "Anverso" ? "Frente" : getSectionName(item.name))}</b></Typography>
                    <ScanContainer>
                        {getSectionName(item.name) == "Selfie" ?
                            <img width={100} className={localStyles.imageCarouselSelfie} src={`data:image/png;base64,${item.image}`} alt="loading..." />
                            : <img width={100} className={localStyles.imageCarousel} src={`data:image/png;base64,${item.image}`} alt="loading..." />}

                    </ScanContainer>
                    {/* </div> */}
                </div>
            ))}
        </div>

        <Buttons
            onClickConfirm={continueToForm}
            CancelButtonText={t("upload_doc_recapture")}
            onClickCancel={reCapture}
        />

        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <Dialog open={openDialog} onClose={() => { setOpenDialog(false) }} maxWidth='lg'>
            <IconButton
                className={localStyles.close}
                onClick={() => { setOpenDialog(false) }}
            >
                <CloseIcon />
            </IconButton>
            <img className={localStyles.imageCarDialog} src={`data:image/png;base64,${newImage}`} alt="loading..." />
        </Dialog>

    </GenericContainer>)
}